import type { AlphaRun } from "@nlc/shared-types";

import { useEffect, useState } from "react";

import {
  type GenerationProgress,
  generationProgress,
} from "../generation/alphaGenerationProgress";

const TICK_INTERVAL_MS = 250;

export function useGenerationProgress(run: AlphaRun): GenerationProgress {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNowMs(Date.now()), TICK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  return generationProgress(run, nowMs);
}
